import React from 'react';
import { Section } from '../ui/Section';
import { Star } from 'lucide-react';
interface TestimonialProps {
  quote: string;
}
function TestimonialCard({
  quote
}: TestimonialProps) {
  return <div className="bg-dark-800/50 border border-dark-700 p-8 rounded-2xl relative group hover:border-gold-500/50 transition-colors duration-300" data-id="element-281">
      <div className="absolute -top-4 left-8 bg-dark-900 px-2 flex gap-1" data-id="element-282">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold-400 fill-current" data-id="element-283" />)}
      </div>
      <p className="text-xl text-gray-200 font-medium italic mt-2" data-id="element-284">"{quote}"</p>
    </div>;
}
export function Testimonials({
  title = '💬 RESULTADOS REALES',
  quotes
}: {
  title?: string;
  quotes: string[];
}) {
  return <Section className="bg-dark-900" data-id="element-285">
      <div className="text-center mb-16" data-id="element-286">
        <h2 className="text-3xl md:text-5xl font-black text-white inline-block relative" data-id="element-287">
          {title}
          <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-24 h-1 bg-gold-gradient rounded-full" data-id="element-288" />
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-289">
        {quotes.map((quote, idx) => <TestimonialCard key={idx} quote={quote} data-id="element-290" />)}
      </div>
    </Section>;
}